import { Directive, ElementRef, Input, OnInit, OnChanges, SimpleChanges, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appDecimalDisplay]'
})
export class DecimalDisplayDirective implements OnInit, OnChanges {
  @Input() appDecimalDisplay: any;
  @Input() maxDecimals: number = 6;
  @Input() defaultDecimals: number = 3;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.formatValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['appDecimalDisplay']) {
      this.formatValue();
    }
  }

  private formatValue() {
    if (this.appDecimalDisplay === null || this.appDecimalDisplay === undefined || this.appDecimalDisplay === '') {
      this.renderer.setProperty(this.el.nativeElement, 'textContent', '-');
      return;
    }

    const value = this.appDecimalDisplay.toString();
    
    // If it's not a number, display as is
    if (isNaN(parseFloat(value))) {
      this.renderer.setProperty(this.el.nativeElement, 'textContent', value);
      return;
    }

    const formattedValue = this.formatDecimalDisplay(value);
    this.renderer.setProperty(this.el.nativeElement, 'textContent', formattedValue);
  }

  private formatDecimalDisplay(value: string): string {
    const num = parseFloat(value);
    
    if (isNaN(num)) {
      return value;
    }

    // Special case: if the number is exactly 0, display as "0"
    if (num === 0) {
      return '0';
    }

    // Convert to string and handle decimal part
    const [integerPart, decimalPart] = value.split('.');

    // If no decimal part, return as is
    if (!decimalPart) {
      return integerPart;
    }

    // Count significant decimal places (non-zero digits)
    const significantDecimals = this.getSignificantDecimals(decimalPart);
    
    // If no significant decimals, return integer part only
    if (significantDecimals === 0) {
      return integerPart;
    }

    // Always show up to maxDecimals, but remove trailing zeros
    const displayDecimals = decimalPart.substring(0, this.maxDecimals);
    const trimmed = displayDecimals.replace(/0+$/, '');
    
    if (trimmed.length === 0) {
      return integerPart;
    }
    
    return `${integerPart}.${trimmed}`;
  }

  private getSignificantDecimals(decimalPart: string): number {
    // Find the last non-zero digit position
    for (let i = decimalPart.length - 1; i >= 0; i--) {
      if (decimalPart[i] !== '0') {
        return i + 1;
      }
    }
    return 0;
  }
}
